/* =========================
   EBUY — Cart recos (Search-like)
   ========================= */
(function () {
  if (window.__EBUY_CART_INIT__) return;
  window.__EBUY_CART_INIT__ = true;
  window.EBUY_CART_INIT = true;

  if (!document.body.classList.contains('template-cart')) return;

  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const $ = (s, r = document) => r.querySelector(s);
  const text = (el) => (el && el.textContent ? el.textContent : '').trim();

  function findRecosSection() {
    // 1) Prefer already tagged container if you set it in theme editor
    let sec =
      $('.ebuy-cart-recos') ||
      $('[data-ebuy-cart-recos]');

    if (sec) return sec.closest('section, .shopify-section, div') || sec;

    // 2) Find by heading text
    const nodes = $$('section, .shopify-section, #MainContent > div');
    for (const node of nodes) {
      const h = $('h2, .title, .section-header__title', node);
      const ht = text(h).toLowerCase();
      if (
        ht.includes('you may also like') ||
        ht.includes('vous aimerez') ||
        ht.includes('recommand')
      ) {
        // Must have a product grid of some form
        const grid = $(
          '.resource-list__grid, .resource-list, .grid, ul, .product-grid',
          node
        );
        if (grid) return node;
      }
    }

    // 3) Fallback: any resource-list grid inside cart
    const grid = $('.resource-list__grid, .resource-list, .product-grid, .grid');
    return grid ? grid.closest('section, .shopify-section, div') : null;
  }

  function findGrid(section) {
    return $(
      '.resource-list__grid, .resource-list, .product-grid, .grid, ul',
      section
    );
  }

  function getItems(grid) {
    const kids = Array.from(grid.children || []);
    // Filter text nodes / empty
    return kids.filter((n) => n && n.nodeType === 1);
  }

  function extractLink(card) {
    return $('a[href*="/products/"]', card) || $('a', card);
  }

  function extractImg(card) {
    return $('img', card);
  }

  function extractTitle(card) {
    const link = extractLink(card);
    const tLink = link ? text(link) : '';
    if (tLink && tLink.length > 2) return tLink;

    return (
      text($('.card__heading, .product-card__title, .resource-card__title, h3, h4', card)) ||
      ''
    );
  }

  function extractPrice(card) {
    const raw =
      text($('.price', card)) ||
      text($('.price-item', card)) ||
      text($('.money', card)) ||
      text($('[class*="price"]', card)) ||
      '';
    return (raw || '').split('\n').map((s) => s.trim()).filter(Boolean)[0] || '';
  }

  function isSoldOut(card) {
    // Try common sold-out markers
    const candidates = $$('.badge, .badge--soldout, .badge--sold-out, .card__badge, .price__badge-sold-out, [class*="sold"]', card);
    const t = candidates.map((c) => text(c).toLowerCase()).join(' | ');
    return t.includes('sold out') || t.includes('épuisé') || t.includes('epuise') || t.includes('rupture');
  }

  function setHeaderLabels(section, count) {
    const header =
      section.querySelector('.resource-list__header') ||
      section.querySelector('.section-header') ||
      section.querySelector('header') ||
      section;

    // PIECE(S)
    let pieces = header.querySelector('.ebuy-cart-pieces');
    if (!pieces) {
      pieces = document.createElement('div');
      pieces.className = 'ebuy-cart-pieces';
      header.prepend(pieces);
    }
    pieces.textContent = (count === 1) ? 'PIECE' : 'PIECES';

    // Title uppercase
    const h2 = header.querySelector('h2, .title, .section-header__title');
    if (h2) h2.classList.add('ebuy-cart-like-title');
  }

  function buildCard({ href, imgEl, title, price, notify }) {
    const a = document.createElement('a');
    a.className = 'ebuy-cart-card' + (notify ? ' is-notify' : '');
    a.href = href || '#';

    const media = document.createElement('div');
    media.className = 'ebuy-cart-media';

    // Put img inside media
    if (imgEl) {
      imgEl.classList.add('ebuy-cart-img');
      media.appendChild(imgEl);
    }

    if (notify) {
      const btn = document.createElement('button');
      btn.className = 'ebuy-cart-notify';
      btn.type = 'button';
      btn.setAttribute('data-ebuy-notify-open', '');
      btn.setAttribute('data-ebuy-notify-img', (imgEl && (imgEl.currentSrc || imgEl.src)) ? (imgEl.currentSrc || imgEl.src) : '');
      btn.setAttribute('data-ebuy-notify-title', title || '');
      btn.setAttribute('data-ebuy-notify-price', price || '');
      btn.textContent = 'Notify me';

      // Prevent navigating the <a>, but still allow drawer code to catch attribute
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });

      media.appendChild(btn);
    }

    const meta = document.createElement('div');
    meta.className = 'ebuy-cart-meta';

    const name = document.createElement('div');
    name.className = 'ebuy-cart-name';
    name.textContent = (title || '').toUpperCase();

    const pr = document.createElement('div');
    pr.className = 'ebuy-cart-price';
    pr.textContent = price || '';

    meta.appendChild(name);
    meta.appendChild(pr);

    a.appendChild(media);
    a.appendChild(meta);

    return a;
  }

  function skin() {
    const section = findRecosSection();
    if (!section) return;

    // ✅ Add reliable hooks for CSS
    section.classList.add('ebuy-cart-skin');

    const grid = findGrid(section);
    if (!grid) return;
    grid.classList.add('ebuy-cart-grid');

    const items = getItems(grid);
    if (!items.length) return;

    setHeaderLabels(section, items.length);

    items.forEach((item) => {
      // Avoid rebuilding twice
      if (item.querySelector(':scope > .ebuy-cart-card')) return;

      const link = extractLink(item);
      const href = link ? link.getAttribute('href') : '#';
      const img = extractImg(item);
      const title = extractTitle(item);
      const price = extractPrice(item);

      const notify = isSoldOut(item);

      // Move existing image node to keep srcset/lazy
      const imgEl = img ? img : null;

      item.innerHTML = '';
      item.appendChild(buildCard({ href, imgEl, title, price, notify }));
    });
  }

  // Run
  skin();
  document.addEventListener('DOMContentLoaded', skin);
  window.addEventListener('load', skin);

  // Observe late-rendered sections
  const target = document.querySelector('#MainContent') || document.body;
  if (target && window.MutationObserver) {
    const obs = new MutationObserver(() => skin());
    obs.observe(target, { childList: true, subtree: true });
  }
})();
